export default {
    path: 'myweb',
    component: () => import('@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'finance-auditbsk'*/ '@views/manage/views/myweb/list'),
            meta: {
                title: '我的门户网站',
            },
        },
    ]
}